import { core } from '../core/index.js';
import { filterFabricErrors } from '../errors/errors.js';

/**
 * 同步接口, 从本地缓存中移除指定 key。
 * @param key 缓存key
 * @returns Promise<boolean>
 */
export const removeStorageSync = (key: string) => {
  const result = core.call<'fabric_storage.removeStorageSync', string, boolean>(
    'fabric_storage.removeStorageSync',
    key
  );
  const fabricErrors = filterFabricErrors(
    result.code,
    result.message,
    result.data
  );
  if (fabricErrors) {
    throw fabricErrors;
  } else {
    return result.data;
  }
};
